import VCalendar from 'v-calendar';
import 'v-calendar/lib/v-calendar.min.css';

export default (Vue) => {
  Vue.use(VCalendar, {
    popoverVisibility: 'focus',
    formats: {
      title: 'MMMM YYYY',
      weekdays: 'W',
      navMonths: 'MMM',
      input: 'YYYY-MM-DD',
      dayPopover: 'YYYY-MM-DD',
      data: 'YYYY-MM-DD',
    },
  });
};



// WEBPACK FOOTER //
// ./src/plugins/index.js